import isVolunteerPreferences from "../../models/resource-management/resource-schedule-guard";
import Volunteer from "../../models/resource-management/volunteers/volunteer";
import { mapLicensedClinician } from "./licensed-clinician-mapper";

function mapVolunteer(data: any): Volunteer {
  let v = new Volunteer(
    data.languages,
    data.volunteerType,
    data.trainingCompletionDate,
    data.title,
    data.preferences
  );

  if (v.preferences && isVolunteerPreferences(v.preferences)) {
    v.preferences.schedule = data.preferences.schedule;
    v.preferences.skillsAndInterests = data.preferences.skillsAndInterests;
  }

  mapLicensedClinician(v, data);

  return v;
}

export { mapVolunteer };



// WEBPACK FOOTER //
// ./src/mappers/resource-management/volunteer-mapper.ts